import constants from '../../../modules/constants';
import './styles.scss';
import { t } from '../../../../../modules/bk/component-property-providers/bk-translations';

class PageHeader extends HTMLElement {
    #headerTitle;
    #secrecyNoteText;
    #labelEnvironment;

    constructor() {
        super();
    }

    static set accountProps(props) {
        if (this.accountProperties) {
            return;
        }
        this.accountProperties = props;
    }

    static get accountProps() {
        return this.accountProperties;
    }

    static get observedAttributes() {
        return ['rm-title', 'rm-secrecy-note-text', 'rm-environment-label'];
    }

    #getHeaderTitle() {
        return this.#headerTitle || t('client.title');
    }

    #getLabelEnvironment() {
        return this.#labelEnvironment || t('global.env.acc');
    }

    #getSecrecyNoteText() {
        return this.#secrecyNoteText || t('rp.note.informationSystemSecrecy');
    }

    attributeChangedCallback(property, oldValue, newValue) {
        if (!PageHeader.observedAttributes.includes(property) || oldValue === newValue) {
            return;
        }

        switch (property) {
            case 'rm-title':
                this.#headerTitle = newValue;
                break;
            case 'rm-environment-label':
                this.#labelEnvironment = newValue;
                break;
            case 'rm-secrecy-note-text':
                this.#secrecyNoteText = newValue;
                break;
        }
    }

    #checkShowCompanyName(headerInfoBox) {
        if (PageHeader.accountProps['showCompanyName']) {
            const headerInfoBoxFirst = document.createElement('div');
            headerInfoBoxFirst.classList.add('user-login-info-first-row');
            headerInfoBoxFirst.innerText = PageHeader.accountProps['accountName'];
            headerInfoBox.appendChild(headerInfoBoxFirst);
        }
    }

    #checkShowSecrecyNote(header) {
        if (PageHeader.accountProps['showSecrecyNote']) {
            header.classList.add('cs-has-secrecy-note');
            const secrecyNote = document.createElement('article');
            secrecyNote.classList.add('bk-cs-secrecy-note');
            secrecyNote.setAttribute('id', 'dSecrecy');
            secrecyNote.innerText = this.#getSecrecyNoteText();
            header.appendChild(secrecyNote);
        }
    }

    #checkEnvironment(header) {
        if (PageHeader.accountProps.isEnvironmentAcceptance) {
            const headerNote = document.createElement('div');
            headerNote.classList.add('bk-cs-header-info');
            if (PageHeader.accountProps['showSecrecyNote']) {
                headerNote.classList.add('bk-cs-header-note');
            }
            headerNote.innerText = this.#getLabelEnvironment();
            header.appendChild(headerNote);
        }
    }

    connectedCallback() {
        const isReportManagementType = this.getAttribute('page-type') === 'rm';
        const header = document.createElement('header');
        header.classList.add('bk-cs-header');

        const headerContent = document.createElement('div');
        headerContent.classList.add('bk-cs-header-content');

        const headerLogo = document.createElement('div');
        headerLogo.classList.add('bk-cs-header-logo');
        headerLogo.setAttribute('aria-hidden', 'true');
        const headerImg = document.createElement('img');
        headerImg.classList.add('bk-cs-header-img');
        headerImg.setAttribute('alt', '');
        headerImg.setAttribute('src', `${constants.contextPath}bkweb-static/all/bkms-logo.svg`);
        headerLogo.appendChild(headerImg);

        const headerH1 = document.createElement('div');
        headerH1.classList.add('bk-cs-header-h1');
        headerH1.innerHTML = isReportManagementType ? this.#getHeaderTitle() : constants.GLOBAL_BKMS_HTML;
        headerLogo.appendChild(headerH1);

        const headerInfoBox = document.createElement('div');
        headerInfoBox.classList.add('user-login-info-box');

        if (PageHeader.accountProps?.userName) {
            const headerInfoBoxSecond = document.createElement('div');
            headerInfoBoxSecond.classList.add('user-login-info-second-row');
            headerInfoBoxSecond.innerText = PageHeader.accountProps.userName;
            this.#checkShowCompanyName(headerInfoBox);
            headerInfoBox.appendChild(headerInfoBoxSecond);

            this.#checkEnvironment(header);
            this.#checkShowSecrecyNote(header);
        }

        const redLine = document.createElement('div');
        redLine.classList.add('bk-cs-line-red');

        header.appendChild(headerContent);
        headerContent.appendChild(headerLogo);
        headerContent.appendChild(headerInfoBox);
        header.appendChild(redLine);

        this.appendChild(header);
    }
}

export default PageHeader;
